module.exports = __webpack_public_path__ + "static/media/crome.8be2cf5b.svg";